module.exports = __webpack_public_path__ + "img/3.5c04bf2e.jpg";